import { apiFetch } from '@/shared/api/client'
import { runKitchenSync } from '@/shared/sync/kitchenSync'

import { isMockApi } from '@/shared/env'
export type StockSource = 'main' | 'return' | 'damaged'

export type WasteProposalLine = {
  productName: string
  productionDate: string
  stockSource: StockSource
  qty: number
  reason?: string
}

export type SubmitWasteRequest = {
  batchId: string
  deviceId: string
  pin: string
  lines: WasteProposalLine[]
  note?: string
}

export type SubmitWasteResponse = {
  submitted_at: string
}

const DEV_PIN = '123456'

function useMockApi(): boolean {
  return isMockApi
}

function mockSubmit(req: SubmitWasteRequest): SubmitWasteResponse {
  if (req.pin !== DEV_PIN) {
    throw new Error('PIN salah. Coba lagi atau hubungi Admin HO jika lupa PIN.')
  }
  const hasQty = req.lines.some((line) => line.qty > 0)
  if (!hasQty) {
    throw new Error('Minimal 1 item dengan jumlah lebih dari 0.')
  }
  const missingReason = req.lines.find(
    (line) =>
      line.qty > 0 &&
      line.stockSource === 'main' &&
      !line.reason?.trim(),
  )
  if (missingReason) {
    throw new Error('Isi alasan untuk setiap produk good stock.')
  }
  return { submitted_at: new Date().toISOString() }
}

export async function submitWasteProposalDirect(
  req: SubmitWasteRequest,
): Promise<SubmitWasteResponse> {
  if (useMockApi()) {
    await new Promise((resolve) => setTimeout(resolve, 500))
    return mockSubmit(req)
  }

  return apiFetch<SubmitWasteResponse>(`/kitchen/waste-batches/${req.batchId}/submit`, {
    method: 'POST',
    body: JSON.stringify({
      device_id: req.deviceId,
      pin: req.pin,
      lines: req.lines,
      note: req.note,
    }),
  })
}

export async function submitWasteProposal(req: SubmitWasteRequest): Promise<SubmitWasteResponse> {
  return runKitchenSync(
    {
      type: 'waste_submit',
      label: `Proposal pemusnahan ${req.batchId}`,
      payload: req,
    },
    () => submitWasteProposalDirect(req),
    () => ({ submitted_at: new Date().toISOString() }),
  )
}
